export const fetchQueryTags = {
  portfolio: 'portfolio',
  portfolioAssets: 'portfolio-assets',
  assetDetailsBase: 'asset-details-base',
  transactionsBase: 'transactions-base',
  cryptoTransfersTransactions: 'crypto-transfers-transactions-details',
  userInfoBase: 'user-info-base',
  appropriatenessQuestionsBase: 'appropriateness-questions-base',
  onboardUserBase: 'onboard-user-base',
  termsAndConditionsBase: 'terms-and-conditions-base',
  savingsPlansBase: 'savings-plans-base',
  cryptoAddressesBase: 'crypto-addresses-base',
  notifications: 'notifications-base',
  fiatWalletBase: 'fiat-wallet-base',
};
